import { AssetPresentationRatioEnum } from '@kaltura-ott/tvpil';

export const checkLandscapeOrientation = (ratio?: string) => {
  return ratio === AssetPresentationRatioEnum['16x9'] || ratio === AssetPresentationRatioEnum['5x3'];
};
